import dayjs from 'dayjs'

import dayjsTimeZone from 'dayjs/plugin/timezone'
import dayjsUtc from 'dayjs/plugin/utc'

dayjs.extend(dayjsUtc)
dayjs.extend(dayjsTimeZone)

export function utcSP(rawDate?: string | Date) {
  const date = dayjs(rawDate).utc(true)

  return {
    formatDate: () =>
      date?.isValid() ? date.tz('America/Sao_Paulo').format('DD/MM/YYYY') : '',
    formatHour: () =>
      date?.isValid()
        ? date.tz('America/Sao_Paulo').format('HH:mm')
        : 'data inválida'
  }
}
